import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Badge, Typography } from 'seagull';
import styles from './RecipientDetails.module.scss';
const typographySkinMap = {
    default: 'secondary',
    error: 'error',
    success: 'success',
    warning: 'warning',
    primary: 'primary'
};
const RecipientDetails = (param)=>{
    let { email, lastName, firstName, companyName, badge, requiredBadgeSkin = 'default', signedBadgeSkin = 'success', requiredBadgeClassName, signedBadgeClassName, nameClassName, testId = 'recipient-details', className } = param;
    const fullName = "".concat(firstName || '', " ").concat(lastName || '').trim();
    const company = companyName ? " (".concat(companyName, ")") : '';
    const emailSuffix = email ? ", ".concat(email) : '';
    const displayText = "".concat(fullName).concat(company).concat(emailSuffix);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.recipientDetails, className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: "".concat(testId, "-text"),
                className: nameClassName,
                children: displayText
            }),
            badge === 'required' && /*#__PURE__*/ _jsx(Badge, {
                rounded: true,
                outlined: true,
                skin: requiredBadgeSkin,
                className: requiredBadgeClassName,
                children: /*#__PURE__*/ _jsx(Typography, {
                    skin: typographySkinMap[requiredBadgeSkin],
                    variant: "paragraph2",
                    testId: "".concat(testId, "-required-badge-text"),
                    children: "Required to sign"
                })
            }),
            badge === 'signed' && /*#__PURE__*/ _jsx(Badge, {
                rounded: true,
                outlined: true,
                skin: signedBadgeSkin,
                className: signedBadgeClassName,
                children: /*#__PURE__*/ _jsx(Typography, {
                    skin: typographySkinMap[signedBadgeSkin],
                    variant: "paragraph2",
                    testId: "".concat(testId, "-signed-badge-text"),
                    children: "Signed"
                })
            })
        ]
    });
};
export default RecipientDetails;
